<template>
  <div class="car-price-details">
    <div v-if="maintenancePositions.length > 0">
      <div class="car-offer-services__item-title--container col col__header--icon" @click="toggleMaintenancePositions()">
        <span class="car-label">{{ $t('quote.calculation.maintenancePositions.title') }}</span>
        <div class="car-maintenance__subtitle--right">
          <span class="car-maintenance__subtitle--item-text">{{maintenancePositions.length}}{{' '}}{{ $t('quote.calculation.maintenancePositions.counter') }}</span>
          <span class="car-maintenance__subtitle--item-text" v-if="!maintenancePositionsVisible">({{ $t('quote.calculation.maintenancePositions.showDetails') }})</span>
          <span class="car-maintenance__subtitle--item-text" v-if="maintenancePositionsVisible">({{ $t('quote.calculation.maintenancePositions.hideDetails') }})</span>
          <icon-chevron-down height="20" width="20" v-if="!maintenancePositionsVisible"></icon-chevron-down>
          <icon-chevron-up height="20" width="20" v-if="maintenancePositionsVisible"></icon-chevron-up>
        </div>
      </div>
      <div class="car-detail__container--maintenance-positions" v-if="maintenancePositionsVisible">
        <div class="car-list-group-content">
          <div class="car-detail__block--subtitle">
            {{ $t('quote.calculation.maintenancePositions.subtitleMandatory') }}
          </div>
          <div class="car-content-list__item--maintenance"
               v-for="(position, index) in maintenanceMandatoryPositions" :key="index">
            <span>{{position.description}}</span>
          </div>
          <div class="car-content-list__item--maintenance">
                  <span v-if="maintenanceMandatoryPositions.length === 0">
                    {{ $t('quote.calculation.maintenancePositions.emptyMandatory') }}
                  </span>
          </div>
        </div>
        <div class="car-list-group-content">
          <div class="car-detail__block--subtitle">
            {{ $t('quote.calculation.maintenancePositions.subtitleOptional') }}
          </div>
          <div class="car-content-list__item--maintenance"
               v-for="(position, index) in maintenanceOptionalPositions" :key="index">
            <span>{{position.description}}</span>
          </div>
          <div class="car-content-list__item--maintenance">
            <span v-if="maintenanceOptionalPositions.length === 0">
              {{ $t('quote.calculation.maintenancePositions.emptyOptional') }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="car-list" v-for="(serviceGroup, serviceType, index) in bookingServices" :key="index">
      <div v-if="serviceGroup.list && serviceGroup.list.positions.length">
        <span class="car-list-label">
          {{ $t(serviceGroup.displayName) }}
        </span>
        <div class="car-items">
          <div class="car-item" v-for="(position, index) in serviceGroup.list.positions"
               :key="index">
                  <span class="car-text car-capitalize" v-if="(serviceType === 'part' || serviceType === 'work') && position.name">{{ position.name.toLowerCase() }}</span>
                  <span class="car-text car-capitalize" v-else-if="(serviceType === 'part' || serviceType === 'work') && position.description">{{ position.description.toLowerCase() }}</span>
                  <span class="car-text" v-else-if="serviceType !== 'fluids'">{{ position.name || position.description }}</span>
                  <span class="car-text" v-if="serviceType === 'fluids'">{{ getPositionName(position) }}</span>
            <span class="car-price">{{ position.actualNetRate || position.actualSurchargeNetRate | currency }}</span>
          </div>
        </div>
      </div>
    </div>
    <!--<div class="car-list-group-head basic">
      <span class="car-label"></span>
      <span class="car-price"></span>
    </div>-->
    <div class="car-list car-prices">
      <div class="car-items">
        <div class="car-item car-net-price">
          <span class="car-label">{{$t('offerServicesReview.netPrice')}}</span>
          <span class="car-price">{{ actualNetRate | currency }}</span>
        </div>
        <div class="car-item car-discount" v-if="selectedOffer.discountList && selectedOffer.discountList.length">
          <span class="car-label">
            {{$t('offerServicesReview.discountsTitle')}}
          </span>
          <div class="car-item" v-for="(item, index) in selectedOffer.discountList" :key="index">
            <span class="car-label">{{item.discount.name}}</span>
            <span class="car-price" v-if="item.position === 0">-{{ selectedOffer.actualNetPrice - item.subtotal | currency }}</span>
            <span class="car-price" v-else>-{{ selectedOffer.discountList[item.position - 1].subtotal - item.subtotal | currency }}</span>
          </div>
          <div class="car-item">
            <span class="car-label">{{$t('offerServicesReview.netPriceDiscounted')}}</span>
            <span class="car-price">{{ selectedOffer.discountedNetPrice | currency }}</span>
          </div>
          <div class="car-item">
            <span class="car-label">{{$t('offerServicesReview.tax')}}</span>
            <span class="car-price">{{ (selectedOffer.discountedNetPrice * selectedOffer.salesTax)/100 | currency }}</span>
          </div>
        </div>
        <div v-else class="car-item car-tax">
          <span class="car-label">
            <span>{{$t('offerServicesReview.tax')}}</span><span> ({{ selectedOffer.salesTax }}%)</span>
          </span>
          <span class="car-price">{{ getGrossPrice() - getNetPrice() | currency }}</span>
        </div>
        <div class="car-item car-final-price">
          <span class="car-label">{{$t('quote.calculation.totalGross')}}</span>
          <span class="car-price">
            {{ getGrossPriceFormatted() }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IconChevronUp from '@/components/icons/IconChevronUp';
import IconChevronDown from '@/components/icons/IconChevronDown';
import utils from '@/services/utils';
import accounting from 'accounting-js';

export default {
  name: 'OfferServicesReview',
  data() {
    return {
      showModal: false,
      maintenancePositionsVisible: false,
      utils: utils,
      grossPrice: this.getGrossPriceFormatted()
    }
  },
  computed: {
    maintenanceMandatoryPositions: function () {
      return this.maintenancePositions ? this.maintenancePositions.filter(item => !item.optional) : []
    },
    maintenanceOptionalPositions: function () {
      return this.maintenancePositions ? this.maintenancePositions.filter(item => item.optional) : []
    }
  },
  props: [
    'valuatedVehicle',
    'selectedOffer',
    'selectedServices',
    'maintenancePositions',
    'actualNetRate',
    'actualGrossRate',
    'regularGrossRate',
    'discountedGrossPrice',
    'discountedNetPrice',
    'bookingServices'
  ],
  methods: {
    toggleMaintenancePositions: function () {
      this.maintenancePositionsVisible = !this.maintenancePositionsVisible;
    },
    getNetPrice: function () {
      return this.actualNetRate;
    },
    getGrossPrice: function() {
      return this.discountedGrossPrice || this.selectedOffer.salesTax / 100 * this.getNetPrice() + this.getNetPrice();
    },
    displayAmount: function (serviceType) {
      return (serviceType !== 'additionalServices' && serviceType !== 'surcharge');
    },
    displayDvn: function (serviceType) {
      return (serviceType !== 'additionalServices' && serviceType !== 'surcharge');
    },
    displayUnitPrice: function (serviceType) {
      return (serviceType !== 'additionalServices' && serviceType !== 'surcharge');
    },
    getGrossPriceFormatted: function() {
      let priceStr = (this.discountedGrossPrice || this.selectedOffer.salesTax / 100 * this.getNetPrice() + this.getNetPrice()).toFixed(2);
      return accounting.formatMoney(accounting.unformat(priceStr, utils.getDecimalSeparator(priceStr)), accounting.settings.currency);
    },
    setGrossPriceFormatted: function() {
      this.grossPrice = this.getGrossPriceFormatted();
    },
    formatGrossPrice: function() {
      this.grossPrice = accounting.formatMoney(accounting.unformat(this.grossPrice.replace(/[^0-9$.,]/g, ''),
        utils.getDecimalSeparator(this.grossPrice.replace(/[^0-9$.,]/g, ''))), accounting.settings.currency)
    },
    getPositionName: function (position) {
      let displayQuery = [];
      let productQuery = [];

      let positionName = position.description || position.name;
      if (positionName) {
        displayQuery.push(positionName);
      }

      if (!position.productId) {
        // if fluid calculation failed, display a message instead of product information
        displayQuery.push(`(${this.$t('quote.calculation.fluidNotAvailable')})`);
      } else if (position.productManufacturer || position.productName || position.productDescription) {
        if (position.productManufacturer) {
          productQuery.push(position.productManufacturer);
        }
        if (position.productName) {
          productQuery.push(position.productName);
        }
        if (position.productDescription) {
          productQuery.push(position.productDescription);
        }
        displayQuery.push('(' + productQuery.join(' ') + ')');
      }

      return displayQuery.join(' ');
    }
  },
  components: {
    IconChevronDown,
    IconChevronUp
  }
}
</script>
